import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import logo from "./../../assets/logo.png";
import { ControlledInput } from "../../common/Input/Input";

export default function EditDeprenuerListingDetailsModal(props) {
    return (
        <Modal
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
    >
        <ModalContent className="ESP-deprenuer-modal">
            {props.isLoadingReports && <Spinner className="center" />}
            <div className="p-2 modal-header-bar">
                <span>Update dePrenuer Listing Details</span>
                <button
                    id="deprenuerClose"
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={props.toggleModal}
                >
                    <X style={{ pointerEvents: "none" }} color="white" />
                </button>
            </div>
            <div
                className={`modal-body ${props.isDisabled} ${props.isLoadingReports && "set-opacity"}`}
            >
                <div className='form-group'>
                    <div>
                        <span>Business Name</span>
                        <ControlledInput
                            placeholder="Business Name"
                            name="sBusinessName"
                            lable="Business Name"
                            value={props.selectedServiceRequestBusinessDetails.sBusinessName}
                            autoComplete="off"
                            onChange={(e) =>{	
                                props.onBusinessDetailsChange(e.target.name, e.target.value);
                            }}
                            disabled={props.selectedServiceRequestBusinessDetails.custrefSRState==="Cancelled"||props.selectedServiceRequestBusinessDetails.custrefSRState==="Delivered"}
                        />
                        {/*<span>Business Description</span>
                        <textarea
                            className="w-100 form-control rounded"
                            name="sBusinessDescription"
                            value={props.selectedServiceRequestBusinessDetails.sBusinessDescription}
                            style={{minHeight:"150px"}}
                            placeholder="Business Details"
                            onChange={(e) =>{			
                                props.onBusinessDetailsChange(e.target.name, e.target.value);
                            }}                            
                            disabled={props.selectedServiceRequestBusinessDetails.custrefSRState==="Cancelled"||props.selectedServiceRequestBusinessDetails.custrefSRState==="Delivered"}
                        />*/}
                    </div>
                    <div>
                        {props.selectedServiceRequestBusinessDetails.custrefSRState=="Cancelled"||props.selectedServiceRequestBusinessDetails.custrefSRState=="Delivered"?
                        (
                            <Button className="float-right disabled" style={{marginTop:"10px"}}>Update</Button>
                        ):
                        (
                            <Button className="float-right" style={{marginTop:"10px"}} onClick={props.onBusinessDetailsUpdate}>Update</Button>
                        )}                            
                    </div>
                    <div style={{clear:"both"}}></div>
                </div>
            </div>
        </ModalContent>
    </Modal >
    );
  }